"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOverclaimHelper = void 0;
const overclaim_share_display_helper_1 = require("@App/helpers/overclaim-share-display-helper");
const isOverclaimHelper = (work) => {
    const totalOverclaim = (0, overclaim_share_display_helper_1.OverclaimShareDisplayHelper)(work === null || work === void 0 ? void 0 : work.totalKnownShares);
    return totalOverclaim ? totalOverclaim > 0 && (work === null || work === void 0 ? void 0 : work.overclaimStatusFilter) === 'OVERCLAIM' : false;
};
exports.isOverclaimHelper = isOverclaimHelper;
